/* Peptagon collection - filtering, sorting, view toggle, variant swap.

   Liquid caps collection.products at 50 per page and the catalog holds more than
   that, so page 1 arrives server-rendered and the rest are pulled through the
   Section Rendering API and appended before the first filter pass. Everything
   downstream (facets, counts, sort) then sees the whole catalog.
   House style: hyphens, not en/em dashes, in UI strings. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pgc]');
  if (!root) return;

  var gridEl = root.querySelector('[data-grid]');
  var tbody = root.querySelector('[data-tbody]');
  var cards = [];
  var rows = [];

  var state = { q:'', area:new Set(), type:new Set(), verified:new Set(),
                stock:new Set(), multi:new Set(), price:new Set(),
                sort:'featured', view:'grid' };
  var SETS = ['area','type','verified','stock','multi','price'];

  var MG = /([\d.]+)\s*mg\b/i;
  function mgFrom(){
    for (var i=0;i<arguments.length;i++){
      var m = String(arguments[i]||'').match(MG);
      if (m) return parseFloat(m[1]);
    }
    return 0;
  }
  function num(el,a){ var v = parseFloat(el.getAttribute(a)); return isNaN(v)?0:v; }
  function money(n){ return '$' + (Math.round(n*100)/100).toFixed(2).replace(/\.00$/,''); }
  function variantsOf(card){
    try { return JSON.parse(card.querySelector('[data-variants]').textContent); } catch(e){ return []; }
  }

  /* --------------------------------------------- load the remaining pages */
  function loadRest(){
    var pages = parseInt(root.getAttribute('data-pages'), 10) || 1;
    var sid = root.getAttribute('data-section-id');
    var base = root.getAttribute('data-collection-url');
    if (pages < 2 || !sid || !base) return Promise.resolve();

    /* the search page hands over a base that already carries ?q=... */
    var sep = base.indexOf('?') > -1 ? '&' : '?';
    var jobs = [];
    for (var n = 2; n <= pages; n++){
      jobs.push(
        fetch(base + sep + 'section_id=' + encodeURIComponent(sid) + '&page=' + n, { credentials:'same-origin' })
          .then(function(r){ return r.ok ? r.text() : ''; })
          .catch(function(){ return ''; })
      );
    }
    return Promise.all(jobs).then(function(htmls){
      var doc = document.implementation.createHTMLDocument('');
      htmls.forEach(function(html){
        if (!html) return;
        doc.body.innerHTML = html;
        var more = doc.querySelectorAll('.pgc-card');
        for (var i=0;i<more.length;i++) gridEl.appendChild(document.importNode(more[i], true));
        if (tbody){
          var mrows = doc.querySelectorAll('[data-prow]');
          for (var j=0;j<mrows.length;j++) tbody.appendChild(document.importNode(mrows[j], true));
        }
      });
    });
  }

  /* ---- resolve mg per variant: variant title first, then product title ---- */
  var titleByPid = {};
  function prep(){
    cards = [].slice.call(gridEl.querySelectorAll('.pgc-card'));
    rows  = tbody ? [].slice.call(tbody.querySelectorAll('[data-prow]')) : [];

    cards.forEach(function(c){
      var pTitle = c.getAttribute('data-title') || '';
      titleByPid[c.getAttribute('data-pid')] = pTitle;
      var vars = variantsOf(c), best = 0;
      vars.forEach(function(v){
        v.mg = mgFrom(v.title, pTitle);
        if (v.mg && v.available){
          var per = (v.price/100)/v.mg;
          if (!best || per < best) best = per;
        }
      });
      c.setAttribute('data-permg', best || 0);
      var s = c.querySelector('[data-variants]');
      if (s) s.textContent = JSON.stringify(vars);

      var onBtn = c.querySelector('.pgc-size.is-on');
      var sel = vars[onBtn ? +onBtn.getAttribute('data-vi') : 0];
      var unit = c.querySelector('.pgc-unit');
      if (unit && sel) unit.textContent = sel.mg ? money((sel.price/100)/sel.mg) + '/mg' : '';
    });

    rows.forEach(function(r){
      var tds = r.querySelectorAll('td');
      if (tds.length < 6) return;
      var price = parseFloat(tds[4].textContent.replace(/[^\d.]/g,''));
      var mg = mgFrom(tds[1].textContent.trim(), titleByPid[r.getAttribute('data-pid')]);
      tds[5].textContent = (mg && !isNaN(price)) ? money(price/mg) : '-';
    });
  }

  /* ---- counts on the facet labels and the header stats, from what loaded ---- */
  function tally(){
    var byType = {}, verified = 0, v995 = 0, instock = 0, multi = 0, lots = 0, psum = 0;

    cards.forEach(function(c){
      var t = c.getAttribute('data-type') || '';
      byType[t] = (byType[t] || 0) + 1;
      if (num(c,'data-purity')) verified++;
      if (num(c,'data-purity') >= 99.5) v995++;
      if (c.getAttribute('data-instock') === '1') instock++;
      if (c.getAttribute('data-multi') === '1') multi++;
      variantsOf(c).forEach(function(v){
        var p = parseFloat(v.purity);
        if (!isNaN(p) && p > 0){ lots++; psum += p; }
      });
    });

    function put(sel, val){ var el = root.querySelector(sel); if (el) el.textContent = val; }
    root.querySelectorAll('[data-count-type]').forEach(function(el){
      el.textContent = byType[el.getAttribute('data-count-type')] || 0;
    });
    put('[data-count-verified]', verified);
    put('[data-count-995]', v995);
    put('[data-count-instock]', instock);
    put('[data-count-multi]', multi);
    put('[data-total]', cards.length);
    put('[data-stat-count]', cards.length);
    put('[data-stat-vcount]', lots);
    if (lots) put('[data-stat-avg]', (Math.round((psum/lots)*100)/100));
  }

  /* ---------------------------------------------------------------- filter */
  function passes(c){
    if (state.q && c.getAttribute('data-title').indexOf(state.q) === -1) return false;

    if (state.area.size){
      var areas = ' ' + (c.getAttribute('data-areas') || '') + ' ', hit = false;
      state.area.forEach(function(h){ if (areas.indexOf(' ' + h + ' ') > -1) hit = true; });
      if (!hit) return false;
    }
    if (state.type.size && !state.type.has(c.getAttribute('data-type'))) return false;
    if (state.verified.has('any') && !num(c,'data-purity')) return false;
    if (state.verified.has('995') && num(c,'data-purity') < 99.5) return false;
    if (state.stock.has('in') && c.getAttribute('data-instock') !== '1') return false;
    if (state.multi.has('multi') && c.getAttribute('data-multi') !== '1') return false;
    if (state.price.size){
      var p = num(c,'data-price')/100, ok = false;
      state.price.forEach(function(r){ var b=r.split('-'); if (p>=+b[0] && p<=+b[1]) ok = true; });
      if (!ok) return false;
    }
    return true;
  }

  function sortKey(c){
    switch(state.sort){
      case 'purity':     return -num(c,'data-purity');
      case 'price-asc':  return num(c,'data-price');
      case 'price-desc': return -num(c,'data-price');
      case 'value':      return num(c,'data-permg') || 1e9;
      case 'az':         return c.getAttribute('data-title');
      default:           return num(c,'data-order');
    }
  }

  var LABELS = { any:'Live COA', '995':'Purity ≥ 99.5%', 'in':'In stock', multi:'Multiple sizes' };
  function labelFor(k, v){
    if (k !== 'area' && k !== 'type' && LABELS[v]) return LABELS[v];
    if (k === 'price') return '$' + v.replace('-99999','+').replace('-','-$');
    if (k === 'area' || k === 'type'){
      var el = root.querySelector('[data-filter="' + k + '"][value="' + v.replace(/"/g,'') + '"]');
      return el ? (el.getAttribute('data-label') || v) : v;
    }
    return v;
  }
  function esc(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function chipHTML(){
    var out = [];
    if (state.q) out.push(['q', state.q, '“' + state.q + '”']);
    SETS.forEach(function(k){
      state[k].forEach(function(v){ out.push([k, v, labelFor(k, v)]); });
    });
    return out.map(function(b){
      return '<span class="pgc-achip">' + esc(b[2]) +
        '<button type="button" data-rmk="' + esc(b[0]) + '" data-rmv="' + esc(b[1]) +
        '" aria-label="Remove filter">×</button></span>';
    }).join('');
  }

  function apply(){
    var visible = 0, ids = {};
    cards.forEach(function(c){
      var ok = passes(c);
      c.hidden = !ok;
      if (ok){ visible++; ids[c.getAttribute('data-pid')] = 1; }
    });
    rows.forEach(function(r){ r.hidden = !ids[r.getAttribute('data-pid')]; });

    var ordered = cards.slice().sort(function(a,b){
      var ka = sortKey(a), kb = sortKey(b);
      if (typeof ka === 'string') return ka.localeCompare(kb);
      if (ka === kb) return num(a,'data-order') - num(b,'data-order');
      return ka - kb;
    });
    ordered.forEach(function(c){ gridEl.appendChild(c); });

    if (tbody && state.sort !== 'featured'){
      var seen = {};
      ordered.forEach(function(c){
        var pid = c.getAttribute('data-pid');
        if (seen[pid]) return; seen[pid] = 1;
        rows.forEach(function(r){ if (r.getAttribute('data-pid') === pid) tbody.appendChild(r); });
      });
    }

    var shown = root.querySelector('[data-shown]'); if (shown) shown.textContent = visible;
    var done  = root.querySelector('[data-donecount]'); if (done) done.textContent = visible;

    var isGrid = state.view === 'grid';
    gridEl.style.display = (visible && isGrid) ? '' : 'none';
    var tw = root.querySelector('[data-tablewrap]');
    if (tw) tw.style.display = (visible && !isGrid) ? '' : 'none';
    var empty = root.querySelector('[data-empty]');
    if (empty) empty.style.display = visible ? 'none' : '';

    var chips = root.querySelector('[data-activechips]');
    if (chips) chips.innerHTML = chipHTML();
  }

  /* --------------------------------------------------- variant switching */
  function setVariant(card, idx){
    var vars = variantsOf(card), v = vars[idx];
    if (!v) return;

    card.querySelectorAll('.pgc-size').forEach(function(b,i){ b.classList.toggle('is-on', i === idx); });

    var price = card.querySelector('.pgc-price'); if (price) price.textContent = money(v.price/100);
    var unit  = card.querySelector('.pgc-unit');
    if (unit) unit.textContent = v.mg ? money((v.price/100)/v.mg) + '/mg' : '';

    var lot = card.querySelector('.pgc-meta .lot');
    if (lot) lot.textContent = v.lot ? 'LOT ' + v.lot : '';

    /* Chip: only ever the holographic verified chip. A lot without a live
       certificate shows no chip at all - the product page's lab report
       covers it, and some products don't require a COA. */
    var shot = card.querySelector('.pgc-shot');
    if (shot){
      var old = shot.querySelector('.pgc-holochip, .pgc-nochip');
      if (v.purity){
        var el = document.createElement('span');
        el.className = 'pgc-holochip';
        if (v.lot) el.title = 'Lot ' + v.lot + ' · ' + v.code;
        el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 4 4L19 7"/></svg> ' + v.purity + '%';
        if (old) old.parentNode.replaceChild(el, old);
        else shot.insertBefore(el, shot.firstChild);
      } else if (old){
        old.parentNode.removeChild(old);
      }
    }

    var coa = card.querySelector('.pgc-coa');
    if (coa){
      if (v.code){
        coa.href = 'https://accumarklabs.com/accuverify/?accuverify_code=' + v.code;
        coa.style.display = '';
      } else { coa.style.display = 'none'; }
    }

    var form = card.querySelector('form[action*="/cart/add"]');
    if (form){
      var id = form.querySelector('input[name="id"]');
      if (id) id.value = v.id;
      var btn = form.querySelector('.pgc-add');
      if (btn){
        btn.disabled = !v.available;
        btn.innerHTML = v.available ? 'Add <span class="sz">' + esc(v.title) + '</span>' : 'Sold out';
      }
    }
  }

  /* ------------------------------------------------------------- events */
  var rail  = root.querySelector('.pgc-rail');
  var scrim = root.querySelector('.pgc-scrim');
  function setRail(open){
    if (!rail) return;
    rail.classList.toggle('is-open', open);
    if (scrim) scrim.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (scrim) scrim.addEventListener('click', function(){ setRail(false); });

  root.addEventListener('click', function(e){
    var size = e.target.closest('.pgc-size');
    if (size && !size.disabled){ setVariant(size.closest('.pgc-card'), +size.getAttribute('data-vi')); return; }

    var rm = e.target.closest('[data-rmk]');
    if (rm){
      var k = rm.getAttribute('data-rmk'), v = rm.getAttribute('data-rmv');
      if (k === 'q'){ state.q=''; var s=root.querySelector('[data-searchbox]'); if(s) s.value=''; }
      else {
        state[k].delete(v);
        root.querySelectorAll('[data-filter]').forEach(function(i){
          if (i.getAttribute('data-filter')===k && i.value===v) i.checked=false;
        });
      }
      apply(); return;
    }

    var tog = e.target.closest('[data-view]');
    if (tog){
      root.querySelectorAll('[data-view]').forEach(function(b){ b.classList.remove('is-on'); });
      tog.classList.add('is-on');
      state.view = tog.getAttribute('data-view');
      apply(); return;
    }

    if (e.target.closest('[data-clear]')){
      state.q=''; SETS.forEach(function(k){ state[k].clear(); });
      root.querySelectorAll('[data-filter]').forEach(function(i){ i.checked=false; });
      var sb=root.querySelector('[data-searchbox]'); if(sb) sb.value='';
      apply(); return;
    }

    var more = e.target.closest('[data-more]');
    if (more){
      var full = root.querySelector('[data-ledefull]');
      full.classList.toggle('is-open');
      more.textContent = full.classList.contains('is-open') ? 'Hide details ↑' : 'Cataloging details ↓';
      return;
    }

    if (e.target.closest('[data-filterbtn]')) return setRail(true);
    if (e.target.closest('[data-raildone]')) return setRail(false);
  });

  root.addEventListener('change', function(e){
    var f = e.target.getAttribute && e.target.getAttribute('data-filter');
    if (f && state[f]){ e.target.checked ? state[f].add(e.target.value) : state[f].delete(e.target.value); apply(); }
    if (e.target.hasAttribute && e.target.hasAttribute('data-sort')){ state.sort = e.target.value; apply(); }
  });

  root.addEventListener('input', function(e){
    if (e.target.hasAttribute && e.target.hasAttribute('data-searchbox')){
      state.q = e.target.value.trim().toLowerCase(); apply();
    }
  });

  /* Pre-apply facets from the URL, e.g. /collections/research-catalog?area=metabolic-pathway-research
     This is what the "Browse all" links on the research-area pages use.
     The search page opts out of q-seeding with data-skip-urlq: its results
     were already filtered by q server-side (title AND body matches), and
     re-applying q as a client title filter would hide body-only matches. */
  function fromUrl(){
    var qs = new URLSearchParams(location.search);
    ['area','type'].forEach(function(k){
      (qs.getAll(k) || []).forEach(function(raw){
        raw.split(',').forEach(function(v){
          v = v.trim(); if (!v) return;
          var box = root.querySelector('[data-filter="' + k + '"][value="' + v.replace(/"/g,'') + '"]');
          if (box){ box.checked = true; state[k].add(v); }
        });
      });
    });
    var q = qs.get('q');
    if (q && !root.hasAttribute('data-skip-urlq')){ state.q = q.trim().toLowerCase(); var sb = root.querySelector('[data-searchbox]'); if (sb) sb.value = q; }
  }

  /* First pass runs on what is already in the DOM so the page is usable
     immediately; the second runs once the remaining pages land. */
  prep(); tally(); fromUrl(); apply();
  loadRest().then(function(){ prep(); tally(); fromUrl(); apply(); });
})();
